import React, { useEffect, useState } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import SelectDropdown from "../shared/SelectDropdown";
import Loan_InquiryHeader from "./Loan_InquiryHeader";
import Loan_InquiryTable from "./Loan_InquiryTable";
import {
  fetchData,
  fetchFormData,
  getValueLabel,
  leadPriorityData,
} from "../../utils/options";
import topTost from "../../utils/topTost";
import { useLocation } from "react-router-dom";
import Input from "../shared/Input";

const Loan_InquiryList = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");

  const [permission, setPermission] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [statusData, setStatusData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [LoanTypedata, setLoanTypeData] = useState([]);
  const [lead_sourcedata, setLead_sourceData] = useState([]);
  const [formInquiryData, setFormInquiryData] = useState({
    lead_priority: "",
    loan_type_id: "",
    lead_source: "",
    status: "",
    customer_name: "",
    assigned_to: "",
    from_date: "",
    to_date: "",
  });
  useEffect(() => {
    const getPermission = async () => {
      const roleId = localStorage.getItem("roleId");
      const M_id = queryParams.get("id");

      const formData = new FormData();
      formData.append("role_id", roleId);
      formData.append("module_id", M_id);

      try {
        const result = await fetchFormData("get-permission", formData, "POST");
        const perm = result?.data;

        setPermission(perm);
      } catch (error) {
        console.error("Error fetching permission", error);
      }
    };

    getPermission();
  }, [M_id]);

  const fetchAllData = async () => {
    const userId = localStorage.getItem("id");
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("moduleId", M_id);
    const branchData = await fetchFormData(
      "list-loan-types-Dropdown",
      formData,
      "POST"
    );

    const lead_sourceData = await fetchFormData(
      "lead-sources-listdrop",
      formData,
      "POST"
    );
    const leadPriority_Data = await fetchFormData(
      "list-lead-prioritiesdropdown",
      formData,
      "POST"
    );
    const statusData = await fetchFormData(
      "loan-inquiry-statusesDrop",
      formData,
      "POST"
    );
    const userData = await fetchFormData(
      "get-employees-listuserdrop",
      formData,
      "POST"
    );

    if (branchData) {
      const branches = branchData.data;
      setLoanTypeData(getValueLabel(branches, "loan_type_name", "id") || []);
    }

    if (lead_sourceData) {
      const user = lead_sourceData.data;
      setLead_sourceData(getValueLabel(user, "source_name", "id") || []);
    }

    if (statusData) {
      const status = statusData.states;
      setStatusData(getValueLabel(status, "loan_inquiry_status", "id") || []);
    }

    if (userData) {
      const user = userData.users;
      setUserData(getValueLabel(user, "name", "id") || []);
    }
  };

  const handleLeadPriorityChange = (selected) => {
    if (selected) {
      setFormInquiryData((prev) => ({
        ...prev,
        lead_priority: selected.value,
      }));
    }
  };
  const handleLoanTypeChange = (selectedCity) => {
    if (selectedCity) {
      setFormInquiryData((prev) => ({
        ...prev,
        loan_type_id: selectedCity.value,
      }));
    }
  };

  const handleleadSourcesChange = (selected) => {
    if (selected) {
      setFormInquiryData((prev) => ({
        ...prev,
        lead_source: selected.value,
      }));
    }
  };

  const handleUserChange = (selected) => {
    if (selected) {
      setFormInquiryData((prev) => ({
        ...prev,
        assigned_to: selected.value,
      }));
    }
  };

  const handleStatusChange = (selectedCity) => {
    if (selectedCity) {
      setFormInquiryData((prev) => ({
        ...prev,
        status: selectedCity.value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!formInquiryData.from_date && formInquiryData.to_date) {
      topTost({
        title: "Please select From Date before selecting To Date.",
        icon: "error",
      });
    } else if (formInquiryData.from_date && !formInquiryData.to_date) {
      topTost({
        title: "To Date is required when From Date is selected",
        icon: "error",
      });
    } else if (
      formInquiryData.from_date &&
      formInquiryData.to_date &&
      new Date(formInquiryData.from_date) > new Date(formInquiryData.to_date)
    ) {
      topTost({
        title: "From Date should be less than or equal to To Date",
        icon: "error",
      });
    } else {
      try {
        const form = new FormData();
        form.append("lead_priority", formInquiryData.lead_priority);
        form.append("loan_type_id", formInquiryData.loan_type_id);
        form.append("status", formInquiryData.status);
        form.append("lead_source", formInquiryData.lead_source);
        form.append("assigned_to", formInquiryData.assigned_to);
        form.append("customer_name", formInquiryData.customer_name);
        form.append("from_date", formInquiryData.from_date);
        form.append("to_date", formInquiryData.to_date);
        form.append("created_by", userId);
        form.append("moduleId", M_id);
        form.append("userId", userId);
        const response = await fetchFormData(
          "loan-inquiries-date",
          form,
          "POST",
          true
        );

        if (response && response.data) {
          console.log("Filtered data:", response.data);
          setFilterData(response.data);
        } else {
        }
      } catch (error) {
        console.error("Filter submit error:", error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleChange = (name, value) => {
    setFormInquiryData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  useEffect(() => {
    fetchAllData();
  }, []);

  const handleClose = () => {
    setShowFilters(!showFilters);
  };

  const handleReset = () => {
    setFormInquiryData({
      lead_priority: "",
      loan_type_id: "",
      lead_source: "",
      status: "",
      assigned_to: "",
      customer_name: "",
      from_date: "",
      to_date: "",
    });
    setFilterData([]);
  };

  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <Loan_InquiryHeader
              onToggleFilter={() => setShowFilters(!showFilters)}
              permission={permission}
            />
          </PageHeader>

          {showFilters && (
            <div className="main-content-top">
              <div className="row">
                <div className="col-lg-12 mt-3">
                  <div className="card stretch stretch-full function-table">
                    <div className="card-body p-10">
                      <form onSubmit={handleSubmit}>
                        <div className="row px-3 mt-3 ">
                          <div className="row mb-4">
                            <div className="col-md-2">
                              <label className="fw-semibold py-2">
                                Inquiry Priority:
                              </label>
                            </div>
                            <div className="col-lg-4">
                              <SelectDropdown
                                options={leadPriorityData}
                                selectedOption={
                                  leadPriorityData.find(
                                    (opt) =>
                                      opt.value ===
                                      String(formInquiryData.lead_priority)
                                  ) || null
                                }
                                value={formInquiryData.lead_priority}
                                defaultSelect="Select inquiry Priority"
                                onSelectOption={handleLeadPriorityChange}
                                icon="feather-flag"
                              />
                            </div>
                            <div className="col-md-2 py-2">
                              <label className="fw-semibold">
                                Inquiry Type:{" "}
                              </label>
                            </div>
                            <div className="col-lg-4">
                              <SelectDropdown
                                options={LoanTypedata}
                                selectedOption={
                                  LoanTypedata.find(
                                    (opt) =>
                                      opt.value === formInquiryData.loan_type_id
                                  ) || null
                                }
                                defaultSelect={"Select Loan Type"}
                                onSelectOption={handleLoanTypeChange}
                                icon="feather-briefcase"
                                value={formInquiryData.loan_type_id}
                                required
                              />
                            </div>
                          </div>

                          <div className="row mb-4">
                            <div className="col-md-2">
                              <label className="fw-semibold">
                                Inquiry Source:
                              </label>
                            </div>
                            <div className="col-lg-4">
                              <SelectDropdown
                                options={lead_sourcedata}
                                selectedOption={
                                  lead_sourcedata.find(
                                    (opt) =>
                                      opt.value === formInquiryData.lead_source
                                  ) || null
                                }
                                defaultSelect={"Select Lead Source"}
                                onSelectOption={handleleadSourcesChange}
                                value={Number(formInquiryData.lead_source)}
                                icon="feather-user"
                              />
                            </div>
                            <div className="col-md-2">
                              <label className="fw-semibold">
                                Inquiry Stage:
                              </label>
                            </div>
                            <div className="col-lg-4">
                              <SelectDropdown
                                options={statusData}
                                selectedOption={
                                  statusData.find(
                                    (opt) =>
                                      opt.value === formInquiryData.status
                                  ) || null
                                }
                                defaultSelect={"Select Inquiry Stage"}
                                onSelectOption={handleStatusChange}
                                icon="feather-settings"
                                value={formInquiryData.status}
                              />
                            </div>
                          </div>

                          <div className="row ">
                            <div className="col-md-6">
                              <Input
                                label="Customer Name "
                                name="customer_name"
                                type="text"
                                value={formInquiryData.customer_name}
                                onChange={handleChange}
                                placeholder="Enter Customer Name"
                                icon="feather-user"
                              />
                            </div>
                            <div className="col-md-2">
                              <label className="fw-semibold">
                                Inquiry Stage:
                              </label>
                            </div>
                            <div className="col-lg-4">
                              <SelectDropdown
                                options={userData}
                                selectedOption={
                                  userData.find(
                                    (opt) =>
                                      opt.value === formInquiryData.assigned_to
                                  ) || null
                                }
                                defaultSelect={"Select Assigned Employee"}
                                onSelectOption={handleUserChange}
                                icon="fa-user-shielld"
                                value={formInquiryData.assigned_to}
                              />
                            </div>
                          </div>
                          <div className="row mb-4">
                            <div className="col-lg-6">
                              <Input
                                label="From Date"
                                name="from_date"
                                type="date"
                                value={formInquiryData.from_date}
                                onChange={handleChange}
                                placeholder="From Date"
                                icon="feather-calendar"
                              />
                            </div>

                            <div className="col-lg-6">
                              <Input
                                label="To Date"
                                name="to_date"
                                type="date"
                                value={formInquiryData.to_date}
                                onChange={handleChange}
                                placeholder="To Date"
                                icon="feather-calendar"
                              />
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-lg-12">
                              <div className="customButton gap-xxl-2 my-xxl-2">
                                <button
                                  type="button"
                                  className="btn btn-lg btn-primary"
                                  disabled={isSubmitting}
                                  onClick={handleClose}
                                >
                                  Close
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-lg btn-primary"
                                  disabled={isSubmitting}
                                  onClick={handleReset}
                                >
                                  Reset
                                </button>

                                <button
                                  type="submit"
                                  className="btn btn-lg btn-primary"
                                  disabled={isSubmitting}
                                >
                                  {isSubmitting ? "Submitting..." : "Search"}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="main-content">
            <div className="row">
              <Loan_InquiryTable
                filteredData={filterData}
                permission={permission}
              />
            </div>
          </div>

          <Footer />
        </div>
      </main>
    </>
  );
};

export default Loan_InquiryList;
